"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _currency = require("@nerdwallet/currency");
var ReviewedAtInfo = function ReviewedAtInfo(_ref) {
  var reviewedAtDate = _ref.reviewedAtDate,
    periodConsideredDate = _ref.periodConsideredDate;
  return /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Type, null, reviewedAtDate)), /*#__PURE__*/_react.default.createElement(_currency.Box, null, /*#__PURE__*/_react.default.createElement(_currency.Type, null, periodConsideredDate)));
};
var _default = ReviewedAtInfo;
exports.default = _default;